import { render, staticRenderFns } from "./StatusDisplayBar.vue?vue&type=template&id=2bb39e86&"
import script from "./StatusDisplayBar.vue?vue&type=script&lang=js&"
export * from "./StatusDisplayBar.vue?vue&type=script&lang=js&"
import style0 from "./StatusDisplayBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb39e86')) {
      api.createRecord('2bb39e86', component.options)
    } else {
      api.reload('2bb39e86', component.options)
    }
    module.hot.accept("./StatusDisplayBar.vue?vue&type=template&id=2bb39e86&", function () {
      api.rerender('2bb39e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/StatusDisplayBar.vue"
export default component.exports